















































































import Vue from 'vue'
import CategoryPostTree from '@/components/product/CategoryPostTree.vue'
import LessonsStats from '@/components/product/LessonsStats.vue'
import InstructorCard from '@/components/product/InstructorCard.vue'

export default Vue.extend({
  components: {
    CategoryPostTree,
    LessonsStats,
    InstructorCard
  },
  props: {
    heroSection: {
      type: Object
    },
    product: {
      type: Object
    },
    instructor: {
      type: Object
    },
    categoryTree: {
      type: Array
    },
    nextPost: {
      type: Object
    },
    completedPosts: Number,
    totalPosts: Number,
    postIdsCompleted: Set,
    categoryIdsCompleted: Set,
    courseCompleted: Boolean,
    productStarted: Boolean
  },
  methods: {
    handleNextPostClick() {
      this.$emit('goToNextPost')
    }
  }
})
